﻿module.exports = function ($, mustache, urlParameters, addToCollection) {
    return {
        results: null,
        init: function () {
            var isSearchPage = $('section.resourceSearch').length > 0;
            if (isSearchPage) {
                this.initForm();
                this.initTabs();
            }
        },
        initForm: function () {
            var self = this; // Used to reference 'this' inside anonymous functions (e.g. click events)
            var keywords = urlParameters.param('keywords');
            var categories = urlParameters.param('categories');
            var from = urlParameters.param('from');
            var to = urlParameters.param('to');
            var collection = urlParameters.param('collection');
            var region = urlParameters.param('region');
            var type = urlParameters.param('type');
            var page = urlParameters.param('page') || 1;
            var resultsPerPage = urlParameters.param('results') || 10;

            // Set the initial form values
            $('#keywords').val(keywords);
            $('.resourceSearch__searchTerms').text(keywords);
            if (categories != null && categories.toLowerCase() != 'all') {
                $("#category input[type=checkbox]").prop("checked", false);
                urlParameters.param('categories').split(",").forEach(function (category) {
                    $("#category input[type=checkbox][value='" + category + "']").prop("checked", true);
                });
            }
            $('#startyear').val(from);
            $('#endyear').val(to);
            $('#collection').val(collection);
            $('#region').val(region);
            $('#resourceType').val(type);
            $('#page').val(page);
            $('#resultsPerPage').val(resultsPerPage);

            // Create year selection events.
            $('#keywords').keyup(function (e) {

                if (e.keyCode == '13') {
                    $('body').removeClass('search-filters-active');
                }

                // Update the you searched label
                $('.resourceSearch__searchTerms').text($("#keywords").val());
                // Get new results
                self.search();
            });

            // Create select change events.
            $('#startyear, #endyear, #collection, #region, #resourceType').change(function () {
                // Reset the page number to 1
                $('#page').val(1);
                // Get new results
                self.search();
            });
            $('#resultsPerPage').change(function () {
                // Reset the page number to 1
                $('#page').val(1);
                // Get new results
                self.search();
            });

            // Create cat selection events
            $('#category input').click(function () {
                // Reset the page number to 1
                $('#page').val(1);
                // Get new results
                self.search();
            });

            // Set the click events on the previous and next buttons
            $('.resourceSearch__results__pagination .prev').click(function (e) {
                e.preventDefault();
                e.stopPropagation();
                var page = parseInt($('#page').val()) - 1;
                if (page > 0) {
                    $('#page').val(page);
                    self.search();
                }
            });
            $('.resourceSearch__results__pagination .next').click(function (e) {
                e.preventDefault();
                e.stopPropagation();
                var page = parseInt($('#page').val()) + 1;
                if (page <= $('#pagination').data('pages')) {
                    $('#page').val(page);
                    self.search();
                }
            });

            // On first load get results.
            this.search();

            // Listen for back events that don't trigger a reload and force a reload
            window.addEventListener('popstate', function(e) {
                //alert('here');
                //self.initForm();
            });
        },
        initTabs: function() {
            $(".resourceSearch__tabs a").click(function (e) {
                e.preventDefault();
                var target = $(this).attr('href');
                if (target && target != '') {
                    $('.resourceSearch__tabs__tab').removeClass('selected');
                    $(this).parent().addClass('selected');
                    $('.resourceSearch__tabContent').hide();
                    $(target).show();
                }
            });
        },
        search: function () {
            // Get the categories
            var categories = new Array();
            $.each($("input[name='categories']:checked"), function () {
                categories.push($(this).val());
            });

            // Update the URL with the parameters
            urlParameters.addParam('keywords', $("#keywords").val());
            urlParameters.addParam('categories', categories.toString());
            urlParameters.addParam('from', $("#startyear").val());
            urlParameters.addParam('to', $("#endyear").val());
            urlParameters.addParam('collection', $("#collection").val());
            urlParameters.addParam('region', $("#region").val());
            urlParameters.addParam('type', $("#resourceType").val());
            urlParameters.addParam('page', $("#page").val());
            urlParameters.addParam('results', $("#resultsPerPage").val());

            // Perform and ajax search
            $.ajax({
                url: '/umbraco/Api/searchapi/Resource',
                type: 'POST',
                traditional: true,
                data: {
                    keywords: $('#keywords').val(),
                    startyear: $('#startyear').val(),
                    endyear: $('#endyear').val(),
                    //category: $('#category').val(),
                    collection: $('#collection').val(),
                    region: $('#region').val(),
                    resourceType: $('#resourceType').val(),
                    skip: ($("#page").val() - 1) * $("#resultsPerPage").val(),
                    take: $("#resultsPerPage").val(),
                    categories: categories
                },
                context: this,
                success: this.loadResults,
                error: function () {
                    //console.log("An error occurred when searching.");
                }
            });
        },
        loadResults: function (jsonData) {
            var self = this; // Used to reference 'this' inside anonymous functions (e.g. click events)
            // Reformat the dates
            jsonData.results.forEach(function (result) {
                result.lastUpdated = new Date(result.lastUpdated).toISOString().replace(/^(\d*)-(\d*)-(\d*).*$/, '$3/$2/$1');
            });

            // Load up the category counts.
            for (var category in jsonData.categoryCounts) {
                if (!jsonData.categoryCounts.hasOwnProperty(category))
                    continue;

                // set the count.
                $('#cat-count-' + category).text(jsonData.categoryCounts[category]);
            }

            // Load the results
            var results = $('#resultsList');
            results.empty();
            var template = $('#results > script').html();
            mustache.parse(template);
            var rendered = mustache.render(template, { items: jsonData.results });
            results.html(rendered);

            // Set the result counts
            if (jsonData.count > 0 && jsonData.skip < jsonData.count) {
                var resultsStart = jsonData.skip + 1;
                var resultsEnd = jsonData.skip + jsonData.results.length;
                $('.resourceSearch__results__header__count--value').text(resultsStart + '-' + resultsEnd + ' of ' + jsonData.count);

                // Build the pagination links
                var resultsPerPage = $("#resultsPerPage").val() || 10;
                var pages = Math.ceil(jsonData.count / resultsPerPage);
                var selectedPage = ((resultsStart - 1) / resultsPerPage) + 1;
                var startPage = Math.max(selectedPage - 3, 1);
                var endPage = Math.min(selectedPage + 3, pages);
                if (selectedPage <= 3) endPage = Math.min(endPage + (4 - selectedPage), pages);
                if (selectedPage > pages - 3) startPage = Math.max(pages - 6, 1);
                $('#pagination').empty();
                $('#pagination').data('pages', pages);
                for (var page = startPage; page <= endPage; page++) {
                    var selected = (page - 1) * resultsPerPage == resultsStart - 1;
                    $('#pagination').append('<a href="#' + page + '" class="pagination__link ' + (selected ? 'selected' : '') + '">' + (page < 10 ? "0" + page : page) + '</a>');
                }
                $('.resourceSearch__results__pagination').show();
                $('#pagination .pagination__link').click(function (e) {
                    e.preventDefault();
                    if (!$(this).hasClass('selected')) {
                        $('#page').val($(this).attr('href').replace('#', ''));
                        self.search();
                    }
                });

                // Show the results
                $('.resourceSearch__results__footer').css('visibility', 'visible');
                $('#resultsPerPage').show();

                // Bind the Add to Collection events
                addToCollection.bindEvents();
            } else {
                $('.resourceSearch__results__header__count--value').text('Your search returned no results.');
                $('.resourceSearch__results__footer').css('visibility', 'hidden');
                $('#resultsPerPage').hide();
            }
            $('.resourceSearch__results__header').css('display', 'flex');

            // Scroll to the top of the results
            $('html, body').animate({
                scrollTop: 0
            }, 500);
        }
    };
};